/**
 *
 * Schema Sample
 *
 */

import React from "react"
import api from "../../helpers/Api"
// import { Badge } from 'reactstrap'
import Y2xpZW50 from "store/Y2xpZW50"
// import c2FsZXMg from "store/c2FsZXMg"
import "./styles.scss"

const clientDetailsSchemaSchema = [
  {
    schemaId: "Y2xpZW50",
    name: "client",
    title: "Client Details",
    formTitle: "Client Details",
    path: "/client-details-old/:id",
    visible: true,
    ...Y2xpZW50,
    page: "ClientDetails",
    exact: true,
    tabs: [
      {
        id: 1,
        value: "sales",
        label: "Sales",
      },
      {
        id: 2,
        value: "event",
        label: "Event Coordinator",
      },
      {
        id: 3,
        value: "account",
        label: "Account",
      },
      {
        id: 4,
        value: "operations",
        label: "Operations",
      },
      {
        id: 5,
        value: "promotion",
        label: "Cross Promotion",
      },
      {
        id: 6,
        value: "activities",
        label: "Activities",
      },
    ],
    clientDetailsColumns: (record = {}) => {
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "primaryMobile",
          label: "Primary No",
          placeholder: "Enter Primary No",
          editRecord: true,
          viewRecord: true,
          required: true,
          onInputChange: ({ inputValue, setFieldValue }) => {
            api
              .post("/get_client", {
                status: "active",
                id: "",
                mobileNo: inputValue.slice(3),
              })
              .then((res) => {
                if (
                  res &&
                  res.data &&
                  res.data.data &&
                  res.data.data.length > 0
                ) {
                  setFieldValue("primaryMobileConfirm", true)
                  setFieldValue(
                    "clientId",
                    res.data.data && res.data.data[0] && res.data.data[0]._id
                  )
                } else {
                  setFieldValue("primaryMobileConfirm", false)
                }
              })
              .catch(() => {
                setFieldValue("primaryMobileConfirm", false)
              })
          },
          prefix: ({ setFieldValue }) => {
            return (
              <div
                style={{ display: "flex", alignItems: "center", width: "32px" }}
              >
                <input
                  type="checkbox"
                  onChange={(e) =>
                    e.target.checked
                      ? setFieldValue("whatsAppNo", record.primaryMobile)
                      : setFieldValue("whatsAppNo", "")
                  }
                ></input>
              </div>
            )
          },
          defaultCountry: "IN",
          type: "phone",
        },
        {
          id: "3",
          value: "secondaryMobile",
          label: "Secondary No",
          placeholder: "Enter Secondary No",
          editRecord: true,
          viewRecord: true,
          onInputChange: ({ inputValue, setFieldValue }) => {
            api
              .post("/get_client", {
                status: "active",
                id: "",
                mobileNo: inputValue.slice(3),
              })
              .then((res) => {
                if (
                  res &&
                  res.data &&
                  res.data.data &&
                  res.data.data.length > 0
                ) {
                  setFieldValue("secondaryMobileConfirm", true)
                  setFieldValue(
                    "clientId",
                    res.data.data && res.data.data[0] && res.data.data[0]._id
                  )
                } else {
                  setFieldValue("secondaryMobileConfirm", false)
                }
              })
              .catch(() => {
                setFieldValue("secondaryMobileConfirm", false)
              })
          },
          prefix: ({ setFieldValue }) => {
            return (
              <div
                style={{ display: "flex", alignItems: "center", width: "32px" }}
              >
                <input
                  type="checkbox"
                  onChange={(e) =>
                    e.target.checked
                      ? setFieldValue("whatsAppNo", record.secondaryMobile)
                      : setFieldValue("whatsAppNo", "")
                  }
                ></input>
              </div>
            )
          },
          defaultCountry: "IN",
          type: "phone",
        },
        {
          id: "4",
          value: "whatsAppNo",
          label: "Whats App No",
          placeholder: "Enter Whats App No",
          editRecord: true,
          viewRecord: true,
          required: true,
          defaultCountry: "IN",
          onInputChange: ({ inputValue, setFieldValue }) => {
            api
              .post("/get_client", {
                status: "active",
                id: "",
                mobileNo: inputValue.slice(3),
              })
              .then((res) => {
                if (
                  res &&
                  res.data &&
                  res.data.data &&
                  res.data.data.length > 0
                ) {
                  setFieldValue("whatsAppNoConfirm", true)
                  setFieldValue(
                    "clientId",
                    res.data.data && res.data.data[0] && res.data.data[0]._id
                  )
                } else {
                  setFieldValue("whatsAppNoConfirm", false)
                }
              })
              .catch(() => {
                setFieldValue("whatsAppNoConfirm", false)
              })
          },
          type: "phone",
        },
        {
          id: "5",
          value: "emailId",
          label: "Email ID",
          placeholder: "Enter Email ID",
          editRecord: true,
          viewRecord: true,
          type: "text",
        },
        {
          id: "6",
          value: "clientLocation",
          label: "Client Location",
          placeholder: "Enter Client Location",
          editRecord: true,
          viewRecord: true,
          type: "text",
        },
        {
          id: "7",
          value: "primaryAddress",
          label: "Address",
          placeholder: "Enter Address",
          editRecord: true,
          viewRecord: true,
          type: "textarea",
        },
        {
          id: "8",
          value: "city",
          label: "City",
          placeholder: "Enter City",
          editRecord: true,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.cityOptions &&
                metaData.cityOptions.length > 0 &&
                metaData.cityOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.cityOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ).label) ||
              ""
            )
          },
          type: "select",
          options: "cityOptions",
        },
        {
          id: "9",
          value: "state",
          label: "State",
          placeholder: "Enter State",
          editRecord: true,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.stateOptions &&
                metaData.stateOptions.length > 0 &&
                metaData.stateOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.stateOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ).label) ||
              ""
            )
          },
          type: "select",
          options: "stateOptions",
        },
        {
          id: "10",
          value: "country",
          label: "Country",
          placeholder: "Enter Country",
          editRecord: true,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.countryOptions &&
                metaData.countryOptions.length > 0 &&
                metaData.countryOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.countryOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ).label) ||
              ""
            )
          },
          type: "select",
          options: "countryOptions",
        },
        {
          id: "11",
          value: "pincode",
          label: "Pincode",
          placeholder: "Enter Pincode",
          editRecord: true,
          viewRecord: true,
          type: "text",
        },
        {
          id: "12",
          value: "clientProfile",
          label: "Client Profile",
          placeholder: "Select Client Profile",
          editRecord: true,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.clientProfileOptions &&
                metaData.clientProfileOptions.length > 0 &&
                metaData.clientProfileOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.clientProfileOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ).label) ||
              ""
            )
          },
          type: "select",
          options: "clientProfileOptions",
        },
        {
          id: "13",
          value: "descriptions",
          label: "Client Profile Remarks",
          placeholder: "Enter Remarks",
          editRecord: true,
          viewRecord: true,
          type: "text",
        },
        {
          id: "14",
          value: "dob",
          label: "Client DOB",
          placeholder: "Enter Client DOB",
          editRecord: true,
          viewRecord: true,
          type: "date",
        },
        {
          id: "15",
          value: "anniversary",
          label: "Client Anniversary",
          placeholder: "Enter Remarks",
          editRecord: true,
          viewRecord: true,
          type: "date",
        },
        {
          id: "16",
          value: "relativeProfile",
          label: "Client Relative Profile",
          placeholder: "Enter Client Relative Profile",
          editRecord: true,
          viewRecord: true,
          type: "text",
        },
        {
          id: "17",
          value: "panCardNumber",
          label: "Pan Card No",
          placeholder: "Enter Pan Card No",
          editRecord: true,
          viewRecord: true,
          type: "text",
        },
        {
          id: "18",
          value: "aadharCardNo",
          label: "Aadhar Card No",
          placeholder: "Enter Aadhar Card No",
          editRecord: true,
          viewRecord: true,
          type: "text",
        },
        {
          id: "19",
          value: "clientOrigin",
          label: "Client Origin",
          placeholder: "Enter Client Origin",
          editRecord: true,
          viewRecord: true,
          type: "text",
        },
        {
          id: "20",
          value: "relationshipStatus",
          label: "Relationship Status",
          placeholder: "Enter Relationship Status",
          editRecord: true,
          viewRecord: true,
          type: "text",
        },
        {
          id: "21",
          value: "socialMediaInfluencer",
          label: "Social Media Influencer",
          placeholder: "Enter Social Media Influencer",
          editRecord: true,
          viewRecord: true,
          type: "text",
        },
        {
          id: "22",
          value: "clientReferral",
          label: "Client Referral",
          placeholder: "Enter Client Referral",
          editRecord: true,
          viewRecord: true,
          type: "text",
        },
      ]
    },
    companyDetailsColumns: () => {
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: true,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "companyId",
          label: "Company",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.companyOptions &&
                metaData.companyOptions.length > 0 &&
                metaData.companyOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.companyOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ).label) ||
              ""
            )
          },
          type: "select",
          options: "companyOptions",
        },
        {
          id: "3",
          value: "branchId",
          label: "Branch",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.branchOptions &&
                metaData.branchOptions.length > 0 &&
                metaData.branchOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.branchOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ).label) ||
              ""
            )
          },
          type: "select",
          options: "branchOptions",
        },
        {
          id: "4",
          value: "leadServiceId",
          label: "Service",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.serviceOptions &&
                metaData.serviceOptions.length > 0 &&
                metaData.serviceOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.serviceOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ).label) ||
              ""
            )
          },
          type: "select",
          options: "serviceOptions",
        },
        {
          id: "5",
          value: "leadSourceId",
          label: "Source",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.sourceOptions &&
                metaData.sourceOptions.length > 0 &&
                metaData.sourceOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.sourceOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ).label) ||
              ""
            )
          },
          type: "select",
          options: "sourceOptions",
        },
        {
          id: "6",
          value: "leadSubSourceId",
          label: "Sub Source",
          sort: true,
          editRecord: true,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.subSourceOptions &&
                metaData.subSourceOptions.length > 0 &&
                metaData.subSourceOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.subSourceOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ).label) ||
              ""
            )
          },
          type: "select",
          options: "subSourceOptions",
        },
        {
          id: "7",
          value: "saleSurge",
          label: "Sales Urge",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          width: 80,
          formatter: (val) => (
            <div style={{ display: "flex", flexWrap: "wrap" }}>{val}</div>
          ),
          type: "select",
          options: [
            {
              label: "HOT",
              value: "HOT",
            },
            {
              label: "WARM",
              value: "WARM",
            },
            {
              label: "COLD",
              value: "COLD",
            },
          ],
        },
        {
          id: "8",
          value: "priorityStatusId",
          label: "Priority Status",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.priorityStatusOptions &&
                metaData.priorityStatusOptions.length > 0 &&
                metaData.priorityStatusOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.priorityStatusOptions.find(
                  (_) => cellContent === _.value.toString()
                ).label) ||
              ""
            )
          },
          type: "select",
          options: "priorityStatusOptions",
        },
        {
          id: "9",
          value: "attachment",
          label: "Attachment",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "textarea",
        },
        {
          id: "10",
          value: "descriptions",
          label: "Remarks",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "textarea",
        },
      ]
    },
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },

      {
        id: "3",
        value: "actions",
        label: "Action",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "brideName",
        label: "Bride Name",
        placeholder: "Enter Company Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        type: "text",
      },
      {
        id: "5",
        value: "brideMobileNo",
        label: "Mobile No",
        // placeholder: 'Enter Bride Name',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "text",
      },
      {
        id: "6",
        value: "brideWhatsappNo",
        label: "Whatsapp No",
        // placeholder: 'Enter Bride Name',
        sort: true,
        editRecord: true, //for form
        viewRecord: true, //for table
        required: true,
        type: "text",
      },
      {
        id: "7",
        value: "brideEmailId",
        label: "Email Id",
        // placeholder: 'Enter Bride Name',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "text",
      },
      {
        id: "8",
        value: "groomName",
        label: "Groom Name",
        // placeholder: 'Enter Company Code',
        sort: true,
        editRecord: true,
        viewRecord: true,
        type: "text",
      },
      {
        id: "9",
        value: "groomMobileNo",
        label: "Mobile No",
        // placeholder: 'Enter Bride Name',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "text",
      },
      {
        id: "10",
        value: "groomWhatsappNo",
        label: "Whatsapp No",
        // placeholder: 'Enter Bride Name',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "text",
      },
      {
        id: "11",
        value: "groomEmailId",
        label: "Email Id",
        // placeholder: 'Enter Bride Name',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "text",
      },
      // {
      //   id: '6',
      //   value: 'status',
      //   label: 'Whats App',
      //   sort: false,
      //   editRecord: false,
      //   viewRecord: true,
      //   formatter: (cellContent, row) =>
      //     row.loading ? (
      //       <p className="card-text placeholder-glow">
      //         <span className="placeholder col-7"></span>
      //       </p>
      //     ) : (
      //       <Badge
      //         className={`font-size-12 badge rounded-pill ${
      //           row.status
      //             ? 'bg-success badge-soft-success'
      //             : 'bg-danger badge-soft-danger'
      //         }`}
      //         color={row.badgeclass}
      //         pill
      //       >
      //         {row.status ? 'Active' : 'Inactive'}
      //       </Badge>
      //     ),
      //   type: 'text',
      // },
      // {
      //   id: '7',
      //   value: 'branches',
      //   label: 'Email Id',
      //   sort: false,
      //   editRecord: false,
      //   viewRecord: false,
      //   type: 'text',
      // },
      // {
      //   id: '8',
      //   value: 'insertedBy',
      //   label: 'Groom Name',
      //   sort: false,
      //   editRecord: false,
      //   viewRecord: false,
      //   type: 'text',
      // },
      // {
      //   id: '9',
      //   value: 'updatedBy',
      //   label: 'Updated By',
      //   sort: false,
      //   editRecord: false,
      //   viewRecord: false,
      //   type: 'text',
      // },
      // {
      //   id: '10',
      //   value: 'createdAt',
      //   label: 'Created Date',
      //   sort: false,
      //   editRecord: false,
      //   viewRecord: false,
      //   type: 'text',
      // },
      // {
      //   id: '11',
      //   value: 'updatedAt',
      //   label: 'Updated Date',
      //   sort: false,
      //   editRecord: false,
      //   viewRecord: false,
      //   type: 'text',
      // },
    ],
    clientDetailsForm: () => [
      {
        id: "1",
        value: "brideName",
        label: "Bride Name",
        placeholder: "Enter Bride Name",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "3",
          md: "3",
          style: {
            paddingRight: "15px",
          },
          className: "client-name",
        },
        type: "text",
      },
      {
        id: "2",
        value: "brideMobileNo",
        label: "Mobile No",
        placeholder: "Enter Mobile No",
        sort: false,
        editRecord: true,
        required: true,
        viewRecord: false,
        colProps: {
          lg: "3",
          md: "3",
          style: {
            paddingRight: "15px",
          },
          className: "client-form-detail",
        },
        type: "text",
      },
      {
        id: "3",
        value: "groomName",
        label: "Groom Name",
        placeholder: "Enter Groom Name",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "3",
          md: "3",
          style: {
            paddingRight: "15px",
          },
          className: "client-form-width",
        },
        type: "text",
      },
      {
        id: "4",
        value: "groomMobileNo",
        label: "Mobile No",
        placeholder: "Enter Mobile No",
        sort: false,
        editRecord: true,
        required: true,
        viewRecord: false,
        colProps: {
          lg: "3",
          md: "3",
          style: {
            paddingRight: "15px",
          },
          className: "client-form-detail",
        },
        type: "text",
      },
      {
        id: "5",
        value: "brideWhatsappNo",
        label: "Whats App No",
        placeholder: "Enter Whats App No",
        sort: false,
        editRecord: true,
        viewRecord: true,
        required: true,
        colProps: {
          lg: "3",
          md: "3",
          style: {
            paddingRight: "15px",
          },
          className: "client-name",
        },
        type: "text",
      },
      {
        id: "6",
        value: "brideEmailId",
        label: "Email Id",
        placeholder: "Enter Email Id",
        sort: false,
        editRecord: true,
        viewRecord: true,
        required: true,
        colProps: {
          lg: "3",
          md: "3",
          style: {
            paddingRight: "15px",
          },
          className: "client-form-detail client-name",
        },
        type: "text",
      },
      {
        id: "7",
        value: "groomWhatsappNo",
        label: "Whats App No",
        placeholder: "Enter Whats App No",
        sort: false,
        editRecord: true,
        viewRecord: true,
        required: true,
        colProps: {
          lg: "3",
          md: "3",
          style: {
            paddingRight: "15px",
          },
          className: "client-form-width",
        },
        type: "text",
      },
      {
        id: "8",
        value: "groomEmailId",
        label: "Email Id",
        placeholder: "Enter Email Id",
        sort: false,
        editRecord: true,
        viewRecord: true,
        required: true,
        colProps: {
          lg: "3",
          md: "3",
          style: {
            paddingRight: "15px",
          },
          className: "client-form-detail",
        },
        type: "text",
      },
      {
        id: "9",
        value: "brideProfile",
        label: "Bride Profile",
        placeholder: "Select Bride Profile",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "select",
        colProps: {
          lg: "3",
          md: "3",
          style: {
            paddingRight: "15px",
          },
          className: "client-name couple-profile",
        },
        formatter: (cellContent, row, rowIndex, metaData) => {
          return (
            (metaData &&
              metaData.clientProfileOptions &&
              metaData.clientProfileOptions.length > 0 &&
              metaData.clientProfileOptions.find(
                (_) => _.value.toString() === cellContent.toString()
              ) &&
              metaData.clientProfileOptions.find((_) => _.value === cellContent)
                .label) ||
            ""
          )
        },
        options: "clientProfileOptions",
      },
      {
        id: "10",
        value: "brideProfileRemark",
        label: "Profile Remark",
        placeholder: "Enter Profile Remark",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "3",
          md: "3",
          style: {
            paddingRight: "15px",
          },
          className: "client-form-detail couple-profile",
        },
        type: "text",
      },
      {
        id: "11",
        value: "groomProfile",
        label: "Groom Profile",
        placeholder: "Select Groom Profile",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "select",
        colProps: {
          lg: "3",
          md: "3",
          style: {
            paddingRight: "15px",
          },
          className: "client-form-width couple-profile",
        },
        formatter: (cellContent, row, rowIndex, metaData) => {
          return (
            (metaData &&
              metaData.clientProfileOptions &&
              metaData.clientProfileOptions.length > 0 &&
              metaData.clientProfileOptions.find(
                (_) => _.value.toString() === cellContent.toString()
              ) &&
              metaData.clientProfileOptions.find((_) => _.value === cellContent)
                .label) ||
            ""
          )
        },
        options: "clientProfileOptions",
      },
      {
        id: "12",
        value: "groomProfileRemark",
        label: "Profile Remark",
        placeholder: "Enter Profile Remark",
        sort: false,
        editRecord: true,
        viewRecord: true,
        required: true,
        colProps: {
          lg: "3",
          md: "3",
          style: {
            paddingRight: "15px",
          },
          className: "client-form-detail profile-remark",
        },
        type: "text",
      },
    ],
    eventColumns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },

      {
        id: "3",
        value: "actions",
        label: "Action",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "event",
        label: "Event Name",
        placeholder: "Enter Company Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        type: "text",
      },
      {
        id: "5",
        value: "eventDate",
        label: "Event Date",
        placeholder: "Enter Company Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        type: "text",
      },
      {
        id: "6",
        value: "crewAssemblyTime",
        label: "Time",
        placeholder: "Enter Company Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        type: "text",
      },
      {
        id: "7",
        value: "venueLocation",
        label: "Location",
        placeholder: "Enter Company Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        type: "text",
      },

      {
        id: "8",
        value: "venueName",
        label: "Venue",
        placeholder: "Enter Company Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        type: "text",
      },
      {
        id: "9",
        value: "crowdStrength",
        label: "Crowd Strength",
        placeholder: "Enter Company Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        type: "text",
      },
      {
        id: "10",
        value: "notes",
        label: "Notes",
        placeholder: "Enter Company Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        type: "text",
      },
    ],
    testcolumns: () => [
      {
        id: "1",
        value: "eventType",
        label: "Event Type",
        placeholder: "Select Event Type",
        sort: true,
        editRecord: true,
        viewRecord: true,
        colProps: {
          lg: "6",
          md: "6",
          style: { paddingRight: "10px" },
        },
        required: true,
        formatter: (cellContent, row, rowIndex, metaData) => {
          console.log("", metaData)
          return (
            (cellContent &&
              metaData &&
              metaData.eventTypeOptions &&
              metaData.eventTypeOptions.length > 0 &&
              metaData.eventTypeOptions.find(
                (_) => cellContent.toString() === _.value.toString()
              ) &&
              metaData.eventTypeOptions.find(
                (_) => cellContent.toString() === _.value.toString()
              ).label) ||
            ""
          )
        },
        type: "select",
        options:
        [
          {
            label: "Hindu Wedding",
            value: "hinduWedding",
          },
          {
            label: "Muslim Wedding",
            value: "muslimWedding",
          },
          {
            label: "Christian Wedding",
            value: "christianWedding",
          },
        ],
      },
      {
        id: "2",
        value: "event",
        label: "Event Details",
        placeholder: "Select Event Details",
        sort: false,
        editRecord: true,
        required: true,
        viewRecord: true,
        colProps: {
          lg: "6",
          md: "6",
          style: {
            paddingRight: "10px",
            //  marginLeft: "-5px"
          },
          className: "event-form-margin",
        },
        formatter: (cellContent, row, rowIndex, metaData) => {
          return (
            (cellContent &&
              metaData &&
              metaData.companyOptions &&
              metaData.companyOptions.length > 0 &&
              metaData.companyOptions.find(
                (_) => cellContent.toString() === _.value.toString()
              ) &&
              metaData.companyOptions.find(
                (_) => cellContent.toString() === _.value.toString()
              ).label) ||
            ""
          )
        },
        type: "select",
        options: "companyOptions",
      },
      {
        id: "3",
        value: "eventDate",
        label: "Date",
        placeholder: "Select Date",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "6",
          md: "6",
          style: {
            paddingRight: "10px",
            //  marginLeft: "6px"
          },
        },
        type: "date",
      },
      {
        id: "4",
        value: "crewAssemblyTime",
        label: "Crew Assembly Time",
        placeholder: "Enter Crew Assembly Time",
        sort: false,
        editRecord: true,
        viewRecord: false,
        colProps: {
          lg: "6",
          md: "6",
          style: {
            paddingRight: "10px",
            //  marginLeft: "-5px"
          },
          className: "event-form-margin",
        },
        type: "text",
      },
      {
        id: "5",
        value: "startTime",
        label: "Start Time",
        placeholder: "Enter Start Time",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "6",
          md: "6",
          style: {
            paddingRight: "10px",
          },
        },
        type: "text",
      },
      {
        id: "6",
        value: "endTime",
        label: "End Time",
        placeholder: "Enter End Time",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "6",
          md: "6",
          style: {
            paddingRight: "10px",
            //  marginLeft: "-5px"
          },
          className: "event-form-margin",
        },
        type: "text",
      },
      {
        id: "7",
        value: "venueLocation",
        label: "Venue Location",
        placeholder: "Select Venue Location",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "6",
          md: "6",
          style: {
            paddingRight: "10px",
          },
        },
        formatter: (cellContent, row, rowIndex, metaData) => {
          return (
            (cellContent &&
              metaData &&
              metaData.cityOptions &&
              metaData.cityOptions.length > 0 &&
              metaData.cityOptions.find(
                (_) => cellContent.toString() === _.value.toString()
              ) &&
              metaData.cityOptions.find(
                (_) => cellContent.toString() === _.value.toString()
              ).label) ||
            ""
          )
        },
        type: "select",
        options: "cityOptions",
      },
      {
        id: "8",
        value: "venueName",
        label: "Venue Name",
        placeholder: "Enter Venue Name",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        onInputChange: ({ inputValue, setFieldValue }) => {
          api
            .post('/get_all_venue', {
              status: 'active',
              id: '',
              Venue: inputValue.slice(3),
            })
            .then((res) => {
              if (
                res &&
                res.data &&
                res.data.data &&
                res.data.data.length > 0
              ) {
                setFieldValue('eventNameConfirm', true)
                setFieldValue(
                  'cityId',
                  res.data.data && res.data.data[0] && res.data.data[0]._id
                )
              } else {
                setFieldValue('eventNameConfirm', false)
              }
            })
            .catch(() => {
              setFieldValue('eventNameConfirm', false)
            })
        },
        colProps: {
          lg: "6",
          md: "6",
          style: {
            paddingRight: "10px",
            //  marginLeft: "-5px"
          },
          className: "event-form-margin",
        },
        type: "text",
      },
      {
        id: "9",
        value: "crowdStrength",
        label: "Crowd Strength",
        placeholder: "Enter Crowd Strength",
        sort: true,
        editRecord: true,
        viewRecord: true,
        type: "text",
        colProps: {
          lg: "6",
          md: "6",
          style: {
            paddingRight: "10px",
          },
        },
      },
      {
        id: "10",
        value: "premium",
        label: "Premium",
        placeholder: "",
        sort: false,
        editRecord: true,
        viewRecord: false,
        colProps: {
          lg: "6",
          md: "6",
          style: {
            paddingRight: "10px",
            //  marginLeft: "-5px"
          },
          className: "event-checkbox premium",
        },
        type: "checkbox",
      },
      {
        id: "11",
        value: "notes",
        label: "Notes",
        placeholder: "Enter Notes",
        sort: true,
        editRecord: true,
        viewRecord: true,
        type: "textarea",
        colProps: {
          lg: "12",
          md: "12",
          style: {
            paddingRight: "10px",
            //  marginLeft: "6px"
          },
        },
      },
      {
        id: "12",
        value: "linkBranch",
        label: "Link To Branch",
        placeholder: "",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: false,
        colProps: {
          lg: "6",
          md: "6",
          style: {
            paddingRight: "10px",
            //  marginLeft: "-5px"
          },
          className: "event-checkbox",
        },
        type: "checkbox",
      },
      {
        id: "20",
        value: "branch",
        label: "Branch",
        placeholder: "Select Branch",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: false,
        colProps: {
          lg: "6",
          md: "6",
          style: {
            paddingRight: "15px",
          },
        },
        type: "select",
        formatter: (cellContent, row, rowIndex, metaData) => {
          return (
            (metaData &&
              metaData.branchOptions &&
              metaData.branchOptions.length > 0 &&
              metaData.branchOptions.find(
                (_) => _.value.toString() === cellContent.toString()
              ) &&
              metaData.branchOptions.find((_) => _.value === cellContent)
                .label) ||
            ""
          )
        },
        options: "branchOptions",
      },
    ],
  },
  // {
  //   schemaId: "c2FsZXMg",
  //   name: "Sales approval",
  //   title: "Sales Approval",
  //   formTitle: "Sales Approval",
  //   path: "/sales-approval",
  //   visible: true,
  //   ...c2FsZXMg,
  //   page: "SalesApproval",
  //   exact: true,
  //   tabs: [
  //     {
  //       id: 1,
  //       value: "sales",
  //       label: "Sales",
  //     },
  //     {
  //       id: 2,
  //       value: "event",
  //       label: "Event Coordinator",
  //     },
  //     {
  //       id: 3,
  //       value: "account",
  //       label: "Account",
  //     },
  //     {
  //       id: 4,
  //       value: "operations",
  //       label: "Operations",
  //     },
  //     {
  //       id: 5,
  //       value: "promotion",
  //       label: "Cross Promotion",
  //     },
  //     {
  //       id: 6,
  //       value: "activities",
  //       label: "Activities",
  //     },
  //   ],
  // },
]

export default clientDetailsSchemaSchema
